
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { DashboardReport } from '@/types/Dashboard'

@Component
export default class ReportSelector extends Vue {
  reports: DashboardReport[] = [
    { id: 'cp', name: 'Capacidad y productividad' },
    { id: 'cpd', name: 'Capacidad y productividad detallado' },
    { id: 'eg', name: 'Estatus de gestión' }
  ]

  selected = new DashboardReport()
  selectionListVisible = false

  @Prop({ required: false, default: '' })
  selectedId: number

  @Watch('selectedId')
  watchSelectedId (value: string) {
    if (value && value !== this.selected.id) {
      let found = this.reports.find(it => it.id === value)
      if (found) {
        this.selected = found
      }
    }
  }

  toggleListVisible () {
    this.selectionListVisible = !this.selectionListVisible
  }

  select (report: DashboardReport) {
    this.selected = report
    this.$emit('select', report)
    this.selectionListVisible = false
  }
}
